// extracted by mini-css-extract-plugin
module.exports = {"header__cart-list-item--image":"HeaderCartListItem_header__cart-list-item--image__ljH2k","header__cart-list-item--name":"HeaderCartListItem_header__cart-list-item--name__NKkpe"};